// extracted by mini-css-extract-plugin
export var playerWrapper = "featureVid-module--playerWrapper--2l4Jv";
export var reactPlayer = "featureVid-module--reactPlayer--zJxJ9";